const LeadsIndex = () => import("@/views/channel/leads/index.vue");
const LeadsView = () => import("@/views/channel/leads/view.vue");
const ContentManagementIndex = () =>
    import("@/views/channel/contentManagement/index.vue");
const EditBlogs = () =>
    import("@/views/channel/contentManagement/editBlogs.vue");
const CreateBlogs = () =>
    import("@/views/channel/contentManagement/createBlogs.vue");

export default {
    path: "channels",
    meta: { label: "Channel" },
    component: {
        render(h) {
            return h("router-view");
        },
    },
    children: [
        // ---------------- LEADS ----------------
        {
            path: "leads",
            name: "Leads",
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                   
                    meta: { requiresAuth: true },
                    component: LeadsIndex,
                },
                {
                    path: "view/:id",
                    name: "Leads Details",
                    meta: { requiresAuth: true },
                    component: LeadsView,
                },
            ],
        },
        // ---------------- CONTENT MANAGEMENT ----------------
        {
            path: "contentManagement",
            name: "Content Management",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(h) {
                    return h("router-view");
                },
            },
            children: [
                {
                    path: "",
                    component: ContentManagementIndex,
                },
                {
                    path: "create",
                    name: "Create Content Management",
                    component: CreateBlogs,
                },
                {
                    path: "edit/:id",
                    name: "Edit Content Management",
                    component: EditBlogs,
                },
            ],
        },
    ],
};
